import { render, staticRenderFns } from "./RegisterPieChart.vue?vue&type=template&id=9bf3cf4a&scoped=true"
import script from "./RegisterPieChart.vue?vue&type=script&lang=js"
export * from "./RegisterPieChart.vue?vue&type=script&lang=js"
import style0 from "./RegisterPieChart.vue?vue&type=style&index=0&id=9bf3cf4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf3cf4a",
  null
  
)

export default component.exports